module.exports = __webpack_public_path__ + "img/course70.1fe69a71.png";